export function getAsType<T>(getter: (key: string) => unknown, keyToGet: string) {
  return getter(keyToGet) as T;
}
